//agent-extra-fees.model.ts

export class ExtraFeesDto {
    RequestId: string;
    ExtraFee: string;
    ModifiedBy: string;
    RequestorId: string;
    Direction: number;
}